import { useQuery } from '@tanstack/react-query';

// Services
import { getMedia } from './mediaService';

/**
 * @description Hook to get a media.
 * @param {string} mediaId - The ID of the media.
 * @param {object} options QueryOptions
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * ContentType, Error>}
 */
export const useMedia = (mediaId, options) => useQuery(
  ['media', `${mediaId}`],
  () => getMedia(mediaId),
  {
    ...options,
  },
);
